<template>
    <div
        ref="settingsMenu"
        class="offcanvas offcanvas-end"
        tabindex="-1"
        id="settingsMenu"
        aria-labelledby="settingsMenuLabel"
        data-bs-backdrop="static"
    >
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="settingsMenuLabel">
                Character Sheet Settings
            </h5>
            <button
                type="button"
                class="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
            ></button>
        </div>
        <div class="offcanvas-body">
            <button @click="goToHome" class="btn btn-primary">
                Back to Cast List
            </button>
            <ul class="list-group">
                <li class="list-group-item">Item 1</li>
                <li class="list-group-item">Item 2</li>
                <li class="list-group-item">Item 3</li>
            </ul>
        </div>
    </div>
</template>

<script>
import { Offcanvas } from "bootstrap";

export default {
    mounted() {
        // Ensure a single instance is created and cached
        this.offcanvas = Offcanvas.getOrCreateInstance(this.$refs.settingsMenu);
    },
    methods: {
        goToHome() {
            // attach listener BEFORE hiding, and run it once
            this.$refs.settingsMenu.addEventListener(
                "hidden.bs.offcanvas",
                () => {
                    this.$router.push({ name: "Home" });
                },
                { once: true }
            );

            // Hide via the single cached instance
            this.offcanvas.hide();
        },
    },
};
</script>

<style></style>

